module.exports = {
      id: "bigboss-usage",
      viewBox: "0 0 24.07 17.875",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#bigboss",
      toString: function () {
        return this.url;
      }
    }